$(function() {
    $(document).on('click', '.js-guide-tab-btn', function(){
        $('.js-guide-tab-btn').removeClass('active');
        $(this).addClass('active');
        let tab = $(this).data('tab');
        $('.js-guide-tab').removeClass('active');
        $('.js-guide-tab[data-tab='+tab+']').addClass('active');
    });
})